import aframe from "aframe";

aframe.registerComponent("flash", {
  schema: {
    times: { type: "int", default: 1 },
    interval: { type: "number", default: 500 }
  },
  init() {
    this.timer = 0;
    this.times = 0;
  },
  tick(t, dt) {
    this.timer += dt;
    if (this.timer > this.data.interval) {
      this.times += 1;
      this.timer = 0;
      if (this.times >= this.data.times * 2 - 1) {
        this.el.parentEl.removeChild(this.el);
      } else {
        this.el.object3D.visible = this.times % 2 === 1;
      }
    }
  }
});
